<template>
  <div class="col-12 my-3">
    <div class="row">

      <div class="col-lg-3">

        <div class="bg-white border rounded shadow p-2">
          <h6>انتخاب نوع ایتم</h6>
          <hr>
          <p @click="addQuestion('textarea')" class="form-json-input">متن</p>
          <p @click="addQuestion('radiobox')" class="form-json-input">گزینه ای</p>
          <p @click="addQuestion('selectbox')" class="form-json-input">لیست کشویی</p>
          <p @click="addQuestion('range')" class="form-json-input">دامنه انتخابی</p>
          <p @click="addQuestion('image')" class="form-json-input">عکس</p>
          <p @click="addQuestion('select-box-with-filter')" class="form-json-input">لیست کشویی با فیلتر</p>
          <p @click="addQuestion('text')" class="form-json-input">متن کوتاه</p>
          <p @click="addQuestion('step')" class="form-json-input">مرحله</p>
          <p @click="addQuestion('authenticated_phone_melicode')" class="form-json-input">تایید انطباق تلفن و کدملی</p>
          <p @click="addQuestion('digital_sign')" class="form-json-input">امضای دیجیتال</p>
          <p @click="addQuestion('combination_text')" class="form-json-input">متن ترکیبی</p>
          <p @click="addQuestion('gate')" class="form-json-input">درگاه</p>
          <p @click="addQuestion('form_product')" class="form-json-input">محصول فرم</p>
          <p @click="addQuestion('form_address')" class="form-json-input">آدرس</p>
          <p @click="addQuestion('check_box')" class="form-json-input">چندانتخابی</p>
          <p @click="addQuestion('category_input')" class="form-json-input">دسته بندی</p>
          <p @click="addQuestion('choose_product_input')" class="form-json-input">انتخاب محصول</p>
          <p @click="addQuestion('choose_multiple_product_input')" class="form-json-input">انتخاب چند محصول</p>
          <p @click="addQuestion('create_shopping_cart_input')" class="form-json-input">ساخت سبد با محصولات انتخابی</p>
          <p @click="addQuestion('star')" class="form-json-input">ستاره</p>
        </div>

        <b-form-checkbox v-model="form.form_questions['answer_without_login']" name="check-button" class="my-3" switch>
          پاسخ بدون ثبت نام
        </b-form-checkbox>

        <b-form-checkbox v-model="form.form_questions['send_sms_after_answer_for_admin']" name="check-button"
                         class="my-3" switch>
          ارسال پیامک بعد از ثبت فرم
        </b-form-checkbox>

        <b-form-checkbox v-model="form.form_questions['send_email_after_answer_for_admin']" name="check-button"
                         class="my-3" switch>
          ارسال email بعد از ثبت فرم
        </b-form-checkbox>

        <div class="form-group mt-4">
          <label v-b-modal.modal-1>
            امتیاز فرم
            <b-icon icon="info-circle-fill"/>
          </label>
          <input type="number" v-model="form.form_questions['total_score']" class="form-control" id="total_score">
        </div>

        <b-modal id="modal-1" hide-footer>
          <div class="text-right" dir="rtl">
            <p>مقدار اگر خالی یا عددی باشد امتیاز محاسبه میشود اما اگر مقدار صفر باشد هیچ امتیازی محاسبه نمیشود.</p>
          </div>
        </b-modal>

      </div>
      <div class="col-lg-9">
        <div class="bg-white border rounded shadow p-2">

          <div class="" v-for="(item,index) in formQuestions" :key="index" v-if="item.visibility != false">


            <textarea-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='textarea'"/>
            <radio-box-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='radiobox'"/>
            <select-box-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='selectbox'"/>
            <range-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='range'"/>
            <image-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='image'"/>
            <step-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='step'"/>
            <digital-sign-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='digital_sign'"/>
            <authenticate-phone-meli-code-input @removeQuestion="removeQuestion(index)" :item="item"
                                                v-if="item.type =='authenticated_phone_melicode'"/>
            <select-box-with-filter-input @removeQuestion="removeQuestion(index)" :item="item"
                                          v-if="item.type =='select-box-with-filter'"/>

            <text-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='text'"/>

            <combination-text @removeQuestion="removeQuestion(index)" :item="item"
                              v-if="item.type =='combination_text'"/>

            <gate-input @removeQuestion="removeQuestion(index)" :item="item"
                        v-if="item.type =='gate'"/>

            <form-product-input @removeQuestion="removeQuestion(index)" :item="item"
                                v-if="item.type =='form_product'"/>

            <form-address-input @removeQuestion="removeQuestion(index)" :item="item"
                                v-if="item.type =='form_address'"/>

            <check-box-input @removeQuestion="removeQuestion(index)" :item="item"
                             v-if="item.type =='check_box'"/>

            <category-input @removeQuestion="removeQuestion(index)" :item="item"
                            v-if="item.type =='category_input'"/>

            <choose-product-input @removeQuestion="removeQuestion(index)" :item="item"
                                  v-if="item.type =='choose_product_input'"/>

            <choose-multiple-product-input @removeQuestion="removeQuestion(index)" :item="item"
                                  v-if="item.type =='choose_multiple_product_input'"/>

            <create-shopping-cart-input @removeQuestion="removeQuestion(index)" :item="item"
                                           v-if="item.type =='create_shopping_cart_input'"/>

            <star-input @removeQuestion="removeQuestion(index)" :item="item"
                        v-if="item.type =='star'"/>

            <b-icon class="mx-1 h4" icon="arrow-up-circle-fill" @click="moveItem('up',index)"/>
            <b-icon class="mx-1 h4" icon="arrow-down-circle-fill" @click="moveItem('down',index)"/>
            <b-icon class="mx-1 config-button h4" icon="three-dots"
                    v-b-modal="`item-config-${item.id}`"/>
            <b-modal :id="`item-config-${item.id}`" hide-footer>
              <div class="text-right" dir="rtl">
                <h4 class="mb-3">{{ item.title }}</h4>

                <div class="form-group ">
                  <label class="mb-0 mr-2">توضیحات</label>
                  <input v-model="item['description']" type="text" class="form-control">
                </div>

                <div class="form-group ">
                  <label class="mb-0 mr-2">placeholder</label>
                  <input v-model="item['placeholder']" type="text" class="form-control">
                </div>

                <b-form-checkbox
                  :checked="item.required !== false"
                  @change="value => $set(item, 'required', value)"
                  switch
                >
                  اجباری
                </b-form-checkbox>

              </div>
            </b-modal>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextareaInput from "./components/TextareaInput.vue";
import RadioBoxInput from "./components/RadioBoxInput.vue";
import SelectBoxInput from "./components/SelectBoxInput.vue";
import RangeInput from "./components/RangeInput.vue";
import ImageInput from "./components/ImageInput.vue";
import SelectBoxWithFilterInput from "./components/SelectBoxWithFilterInput.vue";
import TextInput from "./components/TextInput.vue";
import StepInput from "./components/StepInput.vue";
import DigitalSignInput from "./components/DigitalSignInput.vue";
import AuthenticatePhoneMeliCodeInput from "./components/AuthenticatePhoneMeliCodeInput.vue";
import CombinationText from "./components/CombinationText.vue";
import GateInput from "./components/GateInput.vue";
import FormProductInput from "./components/FormProductInput.vue";
import FormAddressInput from "./components/FormAddressInput.vue";
import CheckBoxInput from "./components/CheckBoxInput.vue";
import CategoryInput from "./components/CategoryInput.vue";
import ChooseProductInput from "./components/ChooseProductInput.vue";
import ChooseMultipleProductInput from "./components/ChooseMultipleProductInput.vue";
import CreateShoppingCartInput from "./components/CreateShoppingCartInput.vue";
import StarInput from "./components/StarInput.vue";

export default {
  name: "CreateFormJson",
  components: {
    CreateShoppingCartInput,
    StarInput,
    ChooseMultipleProductInput,
    ChooseProductInput,
    CategoryInput,
    CheckBoxInput,
    FormAddressInput,
    FormProductInput,
    CombinationText,
    RadioBoxInput,
    TextareaInput,
    SelectBoxInput,
    RangeInput,
    ImageInput,
    SelectBoxWithFilterInput,
    TextInput,
    StepInput,
    DigitalSignInput,
    AuthenticatePhoneMeliCodeInput,
    GateInput
  },
  props: {
    form: {}
  },
  computed: {
    formQuestions() {
      if (this.form.form_questions != '') {
        const questions = this.form.form_questions['form'] || []
        questions.forEach((item) => {
          if (typeof item.required === 'undefined') {
            this.$set(item, 'required', true)
          }
        })
        return questions
      }
      this.form.form_questions = {form: [], total_score: null}
      return this.form.form_questions['form']
    }
  },
  methods: {
    removeQuestion(index) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        this.formQuestions[index]['visibility'] = false
        this.$forceUpdate()
      }
    },
    moveItem(mode, index) {
      let component = this.formQuestions;

      // Move Up
      if (mode === 'up') {
        if (index > 0) {

          component.splice(index - 1, 1, component.splice(index, 1, component[index - 1])[0]);
        }
      }

      // Move Down
      if (mode === 'down') {
        if (index < component.length - 1) {
          component.splice(index + 1, 1, component.splice(index, 1, component[index + 1])[0]);
        }
      }

      // Force component to re-render after modifying the array
      this.$forceUpdate();
    },
    addQuestion(item) {
      let formItemsId = this.formQuestions
          .map(item => Number(item.id))
          .filter(id => !isNaN(id))
      let largestNumber = formItemsId.length === 0 ? 1 : Math.max(...formItemsId)
      let formQuestionLength = largestNumber + 1

      let radioBox = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "radiobox",
        "required": true,
        "placeholder": "",
        "options": [
          {
            "id": "1",
            "label": "ایتم 1",
            "value": 1
          },
        ]
      }

      let textarea = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "textarea",
        "required": true,
        "placeholder": ""
      }

      let selectbox = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "selectbox",
        "required": true,
        "placeholder": "",
        "options": [
          {
            "id": "1",
            "label": "ایتم 1",
            "value": 1
          },
        ]
      }

      let check_box = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "check_box",
        "required": true,
        "placeholder": "",
        "options": [
          {
            "id": "1",
            "label": "ایتم 1",
            "value": 1
          },
        ]
      }

      let range = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "range",
        "required": true,
        "placeholder": "",
        "config": {
          "min": '0',
          "max": '100',
          "step": "1"
        }
      }

      let image = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "image",
        "required": true,
        "placeholder": "",
        "config": {
          "image": ""
        }
      }

      let selectBoxWithFilterInput = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "select-box-with-filter",
        "required": true,
        "placeholder": "",
        "options": [
          {
            "id": "1",
            "label": "ایتم 1",
            "value": 1
          },
        ]
      }

      let text = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "text",
        "required": true,
        "placeholder": "",
        "config": {
          "pattern": ""
        }
      }

      let step = {
        "id": formQuestionLength,
        "title": `مرحله ${formQuestionLength}`,
        "description": "",
        "type": "step",
        "required": true,
        "placeholder": "",
        "config": {
          "send_sms_after_answer": false,
          'admin_approval': false,
          'send_sms_after_admin_approval': false,
        }
      }

      let digitalSign = {
        "id": formQuestionLength,
        "title": `${formQuestionLength}`,
        "description": "",
        "type": "digital_sign",
        "required": true,
        "placeholder": "",
        "config": {
          "verify_with_sms": false,
          'digital_sign_handwrite': false,
          'digital_sign_image': false,
        }
      }

      let authenticated_phone_melicode = {
        "id": formQuestionLength,
        "title": `تایید انطباق تلفن و کدملی`,
        "description": "",
        "type": "authenticated_phone_melicode",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let combination_text = {
        "id": formQuestionLength,
        "title": `متن ترکیبی`,
        "description": "",
        "type": "combination_text",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let gate = {
        "id": formQuestionLength,
        "title": `درگاه`,
        "description": "",
        "type": "gate",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let formProduct = {
        "id": formQuestionLength,
        "title": `یک محصول انتخاب کنید.`,
        "description": "",
        "type": "form_product",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let formAddress = {
        "id": formQuestionLength,
        "title": `آدرس`,
        "description": "",
        "type": "form_address",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let formCategory = {
        "id": formQuestionLength,
        "title": `دسته بندی`,
        "description": "",
        "type": "category_input",
        "required": true,
        "placeholder": "",
        "config": {}
      }


      let choose_product_input = {
        "id": formQuestionLength,
        "title": `انتخاب محصول`,
        "description": "",
        "type": "choose_product_input",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let choose_multiple_product_input = {
        "id": formQuestionLength,
        "title": `انتخاب چند محصول`,
        "description": "",
        "type": "choose_multiple_product_input",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let create_shopping_cart_input = {
        "id": formQuestionLength,
        "title": `ساخت سبد با محصولات انتخابی`,
        "description": "",
        "type": "create_shopping_cart_input",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let star = {
        "id": formQuestionLength,
        "title": `امتیاز`,
        "description": "",
        "type": "star",
        "required": true,
        "placeholder": "",
        "config": {
          "min": 1,
          "max": 5
        }
      }


      if (item == 'radiobox') {
        let baseObject = Object.assign({}, radioBox)
        this.formQuestions.push(baseObject)
      }
      if (item == 'textarea') {
        let baseObject = Object.assign({}, textarea)
        this.formQuestions.push(baseObject)
      }
      if (item == 'selectbox') {
        let baseObject = Object.assign({}, selectbox)
        this.formQuestions.push(baseObject)
      }
      if (item == 'range') {
        let baseObject = Object.assign({}, range)
        this.formQuestions.push(baseObject)
      }
      if (item == 'image') {
        let baseObject = Object.assign({}, image)
        this.formQuestions.push(baseObject)
      }

      if (item == 'text') {
        let baseObject = Object.assign({}, text)
        this.formQuestions.push(baseObject)
      }

      if (item == 'select-box-with-filter') {
        let baseObject = Object.assign({}, selectBoxWithFilterInput)
        this.formQuestions.push(baseObject)
      }

      if (item == 'step') {
        let baseObject = Object.assign({}, step)
        this.formQuestions.push(baseObject)
      }

      if (item == 'digital_sign') {
        let baseObject = Object.assign({}, digitalSign)
        this.formQuestions.push(baseObject)
      }

      if (item == 'authenticated_phone_melicode') {
        let baseObject = Object.assign({}, authenticated_phone_melicode)
        this.formQuestions.push(baseObject)
      }

      if (item == 'combination_text') {
        let baseObject = Object.assign({}, combination_text)
        this.formQuestions.push(baseObject)
      }
      if (item == 'gate') {
        let baseObject = Object.assign({}, gate)
        this.formQuestions.push(baseObject)
      }
      if (item == 'form_product') {
        let baseObject = Object.assign({}, formProduct)
        this.formQuestions.push(baseObject)
      }

      if (item == 'form_address') {
        let baseObject = Object.assign({}, formAddress)
        this.formQuestions.push(baseObject)
      }

      if (item == 'check_box') {
        let baseObject = Object.assign({}, check_box)
        this.formQuestions.push(baseObject)
      }

      if (item == 'category_input') {
        let baseObject = Object.assign({}, formCategory)
        this.formQuestions.push(baseObject)
      }

      if (item == 'choose_product_input') {
        let baseObject = Object.assign({}, choose_product_input)
        this.formQuestions.push(baseObject)
      }

      if (item == 'choose_multiple_product_input') {
        let baseObject = Object.assign({}, choose_multiple_product_input)
        this.formQuestions.push(baseObject)
      }

      if (item == 'create_shopping_cart_input') {
        let baseObject = Object.assign({}, create_shopping_cart_input)
        this.formQuestions.push(baseObject)
      }

      if (item == 'star') {
        let baseObject = Object.assign({}, star)
        this.formQuestions.push(baseObject)
      }

      this.$forceUpdate()
    }
  }
}
</script>


<style scoped>
.form-json-input {
  cursor: pointer;
}

.config-button {
  height: 25px;
  width: 25px;
  padding: 5px;
  border-radius: 50%;
  background: var(--success);
  color: var(--white);
}

</style>